import { render, staticRenderFns } from "./activeLists.vue?vue&type=template&id=9794d83c&scoped=true&"
import script from "./activeLists.vue?vue&type=script&lang=js&"
export * from "./activeLists.vue?vue&type=script&lang=js&"
import style0 from "./activeLists.vue?vue&type=style&index=0&id=9794d83c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9794d83c",
  null
  
)

export default component.exports